<template>
  <!-- 스펙234_개선_14: 불러오기 완료 임시 목록 (하단 50%) -->
  <div class="crl">
    <div class="toolbar">
      <button @click="reload">조회</button>
      <button class="ghost" @click="removeChecked" :disabled="checked.length===0">삭제</button>
      <button class="ghost" @click="clearAll">전체 삭제</button>
      <button class="ghost" @click="excludeOpen=true">불러오기 제외할 cafe24 ID</button>
      <!-- [테스트] 아바타 강제생성 / 추가테스트 버튼은 전 role 에서 감춤(핸들러는 유지) -->
      <span class="spacer"></span>
      <button class="recv" @click="collect" :disabled="busy">{{ busy ? '불러오는 중…' : '불러오기' }}</button>
      <button class="apply" @click="applyToCustomer" :disabled="busy">고객정보에 적용</button>
    </div>
    <p v-if="msg" class="msg">{{ msg }}</p>

    <div class="table-scroll">
      <table class="grid">
        <thead><tr><th style="width:44px;">선택</th><th>로그인ID</th><th>이름</th></tr></thead>
        <tbody>
          <tr v-for="r in list" :key="r.id">
            <td class="center"><input type="checkbox" :value="r.id" v-model="checked" /></td>
            <td>{{ r.loginId }}</td>
            <td>{{ r.name }}</td>
          </tr>
          <tr v-if="list.length===0"><td colspan="3" class="empty">데이터가 없습니다.</td></tr>
        </tbody>
      </table>
    </div>

    <!-- 고객정보에 적용 완료 팝업 -->
    <div v-if="appliedOpen" class="done-mask" @click.self="appliedOpen=false">
      <div class="done-card">
        <button class="done-x" @click="appliedOpen=false" aria-label="닫기">×</button>
        <div class="done-badge">
          <svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5" /></svg>
        </div>
        <div class="done-title">적용 완료</div>
        <p class="done-msg">임시 목록의 고객정보를 반영했습니다.</p>
        <ul class="done-notes">
          <li>전산 우상단 <b>수정</b> 버튼에서 추천인·후원인id·센터를 설정하세요.</li>
          <li>적용하신 분은 이름이 없을 수 있으니 이름도 확인하세요.</li>
          <li>주문하지 않으신 고객은 우상단 <b>추가</b> 버튼으로 등록하세요.</li>
        </ul>
        <button class="done-ok" @click="appliedOpen=false">확인</button>
      </div>
    </div>

    <!-- 저장 제외 관리 팝업 -->
    <CustomerExcludeDialog v-if="excludeOpen" @close="excludeOpen=false" />
  </div>
</template>

<script>
import api from '../api';
import CustomerExcludeDialog from '../components/CustomerExcludeDialog.vue';

function today() {
  const d = new Date();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return d.getFullYear() + '-' + m + '-' + day;
}

export default {
  name: 'CustomerReceiveList',
  components: { CustomerExcludeDialog },
  data() {
    return { list: [], checked: [], msg: '', busy: false, excludeOpen: false, appliedOpen: false };
  },
  created() { this.reload(); },
  methods: {
    // [테스트] 불러오기 완료 임시 목록에 1건 추가
    async addTest() {
      this.busy = true; this.msg = '';
      try {
        const res = await api.custReceiveTestAdd();
        this.msg = (res && res.message) || '임시 목록에 1건 추가했습니다.';
        await this.reload();
      } catch (e) {
        this.msg = (e && e.response && e.response.data && e.response.data.message) || e.message;
      } finally { this.busy = false; }
    },
    // 스펙234_개선_41 [테스트] 아바타 강제생성 : 생성자(본체) 로그인id 입력 → 스펙41 배치규칙대로 아바타 1개 생성
    async avatarTest() {
      const loginId = window.prompt('아바타를 강제 생성할 생성자(본체) 로그인id를 입력하세요');
      if (loginId == null || !loginId.trim()) return;
      this.busy = true; this.msg = '';
      try {
        const res = await api.avatarTestForce({ loginId: loginId.trim() });
        const d = (res && res.data) || {};
        window.alert('아바타 강제생성 완료\n생성자: ' + (d.generatorLogin || loginId.trim())
          + '\n아바타: ' + d.avatarLogin
          + '\n부모id: ' + d.parentId + ' / leg: ' + d.leg + ' / depth: ' + d.depth);
        this.$emit('applied');   // 상단(고객정보/조직도) 재조회 트리거
      } catch (e) {
        window.alert('아바타 강제생성 실패: ' + ((e && e.response && e.response.data && e.response.data.message) || e.message));
      } finally { this.busy = false; }
    },
    async reload() {
      this.msg = ''; this.checked = [];
      try { const res = await api.custReceiveTemp(); this.list = res.data || []; }
      catch (e) { this.msg = e.message; this.list = []; }
    },
    // 삭제: 체크 항목 삭제
    async removeChecked() {
      if (this.checked.length === 0) return;
      if (!window.confirm('체크한 항목을 삭제하시겠습니까?')) return;
      try { await api.custReceiveTempDelete(this.checked.slice()); this.reload(); }
      catch (e) { this.msg = e.message; }
    },
    // 전체 삭제
    async clearAll() {
      if (!window.confirm('임시 테이블 전체를 삭제하시겠습니까?')) return;
      try { await api.custReceiveClear(); this.reload(); }
      catch (e) { this.msg = e.message; }
    },
    // 불러오기: 확인 → 고객수신 배치(dt=오늘) 실행 → 완료 시 하단 목록 재조회
    async collect() {
      if (this.busy) return;
      if (!window.confirm('주문하신 고객의 id, 이름을 cafe24 에서 불러와 전산에 저장합니다. 실행하시겠습니까?')) return;
      this.busy = true; this.msg = '';
      try {
        const res = await api.custReceiveCollect(today());
        this.msg = (res && res.message) ? res.message : '고객수신 완료';
        await this.reload();
      } catch (e) {
        this.msg = (e && e.response && e.response.data && e.response.data.message) || e.message || '고객수신 실패';
      } finally {
        this.busy = false;
      }
    },
    // 고객정보에 적용: 임시 → 고객정보 입력 후 임시 클리어 → 완료 팝업
    async applyToCustomer() {
      if (this.busy) return;
      if (this.list.length === 0) { this.msg = '적용할 임시 저장 내역이 없습니다.'; return; }
      if (!window.confirm('임시 테이블 내용을 고객정보에 적용하시겠습니까?')) return;
      this.busy = true; this.msg = '';
      try {
        await api.custReceiveApply();
        await this.reload();
        this.$emit('applied');      // 상단(고객정보) 재조회 트리거
        this.appliedOpen = true;    // 적용 완료 팝업
      } catch (e) {
        this.msg = (e && e.response && e.response.data && e.response.data.message) || e.message || '적용 실패';
      } finally {
        this.busy = false;
      }
    }
  }
};
</script>

<style scoped>
.crl { padding: 2px; }
.toolbar { display: flex; align-items: center; gap: 8px; margin: 8px 0; flex-wrap: wrap; }
.toolbar .spacer { flex: 1 1 auto; }
.toolbar button { height: 30px; border: 1px solid #4d8bff; background: #4d8bff; color: #fff; border-radius: 6px; padding: 0 14px; cursor: pointer; font-size: 13px; }
.toolbar button.ghost { background: #fff; color: #33405c; border-color: #cfd6e6; }
.toolbar button.recv { background: #2e8b57; border-color: #2e8b57; }
.toolbar button.apply { background: #c0392b; border-color: #c0392b; }
.toolbar button:disabled { opacity: .55; cursor: default; }
.msg { color: #c0392b; font-size: 13px; margin: 4px 0; }
.table-scroll { overflow: auto; border: 1px solid #e4e9f2; border-radius: 8px; max-height: 34vh; }
.grid { width: 100%; border-collapse: collapse; font-size: 13px; }
.grid th, .grid td { border-bottom: 1px solid #e4e9f2; padding: 6px 8px; white-space: nowrap; }
.grid thead th { background: #f2f5fb; color: #33405c; }
.grid td.center { text-align: center; }
.grid .empty { text-align: center; color: #8a95ab; padding: 16px; }
button { border-radius: 6px; padding: 0 12px; cursor: pointer; font-size: 13px; height: 30px; border: 1px solid #cfd6e6; background: #fff; color: #33405c; }

/* 세련된 완료 팝업 */
.done-mask { position: fixed; inset: 0; background: rgba(17,24,39,.45); display: flex; align-items: center; justify-content: center; z-index: 60; }
.done-card { position: relative; background: #fff; border-radius: 16px; width: 420px; max-width: 92vw; padding: 30px 26px 24px; text-align: center;
             box-shadow: 0 18px 50px rgba(0,0,0,.22); animation: doneIn .18s ease-out; }
@keyframes doneIn { from { opacity: 0; transform: translateY(8px) scale(.98); } to { opacity: 1; transform: none; } }
.done-x { position: absolute; top: 10px; right: 12px; width: 30px; height: 30px; border: none; background: transparent; color: #9aa4b2; font-size: 22px; line-height: 1; cursor: pointer; }
.done-x:hover { color: #4b5563; }
.done-badge { width: 62px; height: 62px; margin: 4px auto 14px; border-radius: 50%; background: linear-gradient(135deg,#34c76a,#1f9d55);
              display: flex; align-items: center; justify-content: center; box-shadow: 0 8px 20px rgba(31,157,85,.35); }
.done-title { font-size: 19px; font-weight: 800; color: #1f2937; letter-spacing: -.2px; }
.done-msg { font-size: 13.5px; color: #4b5563; margin: 8px 0 14px; }
.done-notes { list-style: none; padding: 12px 14px; margin: 0 0 20px; text-align: left; background: #f4f8f5; border: 1px solid #e2efe7; border-radius: 10px; }
.done-notes li { position: relative; font-size: 12.5px; color: #40556a; line-height: 1.55; padding-left: 16px; margin: 3px 0; }
.done-notes li::before { content: '•'; position: absolute; left: 3px; color: #1f9d55; font-weight: 700; }
.done-notes b { color: #1f2937; }
.done-ok { height: 40px; min-width: 120px; padding: 0 22px; border: none; border-radius: 10px; background: #1f9d55; color: #fff;
           font-size: 14px; font-weight: 700; cursor: pointer; }
.done-ok:hover { background: #18864a; }
</style>
